// On-Chain-Token-Icon-Registry: Symbol → Bild-URL.
//
// SPL-Token (NAKMAK, NOODLE, DXP …) stehen NICHT in CoinGecko/COIN_MAP → CoinImage
// findet kein Logo und zeigt den Buchstabenkreis. Beim Solana-Import hängt
// `solana-wallet-sync` das echte On-Chain-Icon (Helius DAS) an jede TX
// (`coinIcon` / `coinIconIn` / `coinIconOut`). Hier sammeln wir diese Bilder einmal
// in eine Symbol→URL-Map, damit CoinImage sie ÜBERALL (Bestandsliste, TX-Zeilen,
// Charts) als Fallback nutzen kann — nicht nur in der Zeile, die das Icon trägt.
//
// Reiner Modul-Cache (kein State/Firestore): wird bei jedem TX-Load neu befüllt.

const _icons = new Map(); // SYMBOL (uppercase) → https-URL

const up = (s) => String(s || '').trim().toUpperCase();
const isHttps = (u) => typeof u === 'string' && /^https:\/\//i.test(u);

function _set(sym, url) {
  const k = up(sym);
  if (k && isHttps(url) && !_icons.has(k)) _icons.set(k, url);
}

/**
 * Liest alle `coinIcon*`-Felder aus den TX und füllt die Symbol→URL-Map.
 * Idempotent; erste gefundene URL pro Symbol gewinnt.
 * @param {Array} txs
 */
export function registerTokenIcons(txs) {
  for (const tx of txs || []) {
    if (tx.coinIcon)    _set(tx.coin    || tx.sym,    tx.coinIcon);
    if (tx.coinIconIn)  _set(tx.coinIn  || tx.symIn,  tx.coinIconIn);
    if (tx.coinIconOut) _set(tx.coinOut || tx.symOut, tx.coinIconOut);
  }
}

/** @returns {string|null} On-Chain-Icon-URL für ein Symbol, oder null. */
export function getTokenIcon(sym) {
  return _icons.get(up(sym)) || null;
}

/** Nur für Tests: Registry leeren. */
export function _clearTokenIcons() {
  _icons.clear();
}
